import { User } from '@/shared/user';
import { State } from '@/stores/user/state';
import { Route } from 'vue-router';
import { GetterTree } from 'vuex';

export class Getters implements GetterTree<State, any> {
    [key: string]: (state: State, getters: any, rootState: any, rootGetters: any) => any;

    public user = (state: State) => {
        return state.user;
    }

    public hasAnyRole = (state: State) => (roles: Array<string>) => {
        if (state.user == null || state.user.roles == null) {
            return false;
        }
        const userRoles = state.user.roles.map((role) => {
            role.name = role.name.toLowerCase();
            return role;
        });

        roles = roles.map((roleName: string) => {
            return roleName.toLowerCase();
        });

        return userRoles.some((r) => roles.indexOf(r.name) > -1);
    }

    public isAdministrator = (state: State): boolean => this.hasAnyRole(state)(['System', 'Administrator']);
    public isCustomerExperienceExecutive = (state: State): boolean => this.hasAnyRole(state)(['System', 'Administrator', 'Customer experience executive']);
    public isCustomerExperienceExecutiveTeamLeader = (state: State): boolean => this.hasAnyRole(state)(['System', 'Administrator', 'Customer experience executive team leader', 'Head of Customer Experience Team']);
    public isDataCreationExecutive = (state: State): boolean => this.hasAnyRole(state)(['System', 'Administrator', 'Data creation executive']);
    public isDataCreationTeamLeader = (state: State): boolean => this.hasAnyRole(state)(['System', 'Administrator', 'Data creation team leader']);
    public isHeadOfCustomerExperienceTeam = (state: State): boolean => this.hasAnyRole(state)(['System', 'Administrator', 'Head of Customer Experience Team']);
    public isHeadOfDepartment = (state: State): boolean => this.hasAnyRole(state)(['System', 'Administrator', 'PP Key Stakeholder']);
    public isInternalKeyStakeholder = (state: State): boolean => this.hasAnyRole(state)(['System', 'Administrator', 'Internal Key Stakeholder']);
    public isLegalAdvisor = (state: State): boolean => this.hasAnyRole(state)(['System', 'Administrator', 'Legal advisor']);
    public isLegalAssistant = (state: State): boolean => this.hasAnyRole(state)(['System', 'Administrator', 'Legal assistant']);
    public isDuplicateManager = (state: State): boolean => this.hasAnyRole(state)(['System', 'Administrator', 'Manage duplicates']);
    public isProbateLegalAdvisor = (state: State): boolean => this.hasAnyRole(state)(['System', 'Administrator', 'Probate legal advisor']);
    public isSystem = (state: State): boolean => this.hasAnyRole(state)(['System']);

    public hasPermissionForRoute = (state: State) => (route: Route): boolean => {
        if (state.user == null || state.user.roles == null) {
            return false;
        }

        if (!route.meta.requiresAuthentication || route.meta.requiresAnyRole == null || route.meta.requiresAnyRole.length < 1) {
            return true;
        }

        return this.hasAnyRole(state)(route.meta.requiresAnyRole || []);
    }

    public isSystemUser = (state: State) => (user: User): boolean => {
        return user != null && user.roles.some((r) => r.name === 'System');
    }
}
